import React, { Component } from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import styles from './styles'
import translator from '../../translate'
import { withSnackbar } from 'notistack'
import { get as getCookie, remove as removeCookie } from 'es-cookie'
import {
  FormControl,
  Input,
  InputAdornment,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
  CircularProgress,
} from '@material-ui/core'
import Requirements from './requirements'
import { userRenewPasswordService } from '../../api/user-password'
import { customerPortal } from '../../api/limit'
import { authenticationDeleteAction } from '../../reducers/authentication/action'
import UserType from 'src/model/user-types'
import { userGetSelfAction } from '../../reducers/user/action'
import { track } from '@amplitude/analytics-browser'
import { CoreButton, CoreIconButton } from 'src/components/core'
import { Icon } from '@iconify/react'

const SUBSCRIPTION_BOUND_ROLES = [
  'Premium',
  'Premium Plus',
  'Super Admin',
  'Premium Admin Account (Quarterly)',
  'Premium Admin Account (Starter)',
  'Starter - Legacy',
  'Starter',
  'Starter - A',
  'Premium - A',
  'Premium v2',
  'Premium Plus v2',
  'AppSumo (Tier 6)',
  'AppSumo (Tier 7)',
  'AppSumo (Tier 8)',
  'AppSumo (Tier 9)',
  'Elite',
  'Pro',
  'Plus',
  'Pro v2',
  'Launch',
  'Essentials',
  'Growth',
]

class SetPasswordContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      hideFormArea: false,
      name: '',
      long: false,
      number: false,
      lowercase: false,
      uppercase: false,
      special: false,
      password: '',
      showPassword: false,
      disabled: true,
      openAlert: false,
      openDeleteDialog: false,
      openPaymentDialog: false,
      type: window.CONSTANTS.USER_ROLE_ID,
      loading: 0,
    }
  }

  handleLogoutOpenPopup = () => {
    removeCookie('token')
    window.location.href = '/'
  }

  onHandleSetPassword = async () => {
    const { password } = this.state
    const repassword = password
    if (password && repassword) {
      const data = {
        password,
        repassword,
      }
      let response = null
      try {
        response = await userRenewPasswordService(data)
      } catch (error) {
        this.setState({ openAlert: true })
      }

      if (response && response.statusCode == 200) {
        this.setState({ hideFormArea: true }, () => {
          this.handleLogoutOpenPopup()
        })
      }
    }
  }

  handleChange = () => event => {
    const regexForLong = new RegExp('(?=.{8,})')
    const regexForNumber = new RegExp('(?=.*[0-9])')
    const regexForLowercase = new RegExp('(?=.*[a-z])')
    const regexForUppercase = new RegExp('(?=.*[A-Z])')
    const regexForSpecial = new RegExp('(?=.*[!@#$%^&*])')

    const long = regexForLong.test(event.target.value)
    const number = regexForNumber.test(event.target.value)
    const lowercase = regexForLowercase.test(event.target.value)
    const uppercase = regexForUppercase.test(event.target.value)
    const special = regexForSpecial.test(event.target.value)

    this.setState({
      password: event.target.value,
      long,
      number,
      lowercase,
      uppercase,
      special,
      disabled: !(long && number && lowercase && uppercase && special),
    })
  }

  handleCloseAlert = () => {
    this.setState({ openAlert: false })
  }

  handleClickShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword })
  }

  handleMouseDownPassword = event => {
    event.preventDefault()
  }

  handleDirectUrl = () => {
    this.setState({ loading: 1 })
    customerPortal()
      .then(response => {
        const sessionUrl = response.data.sessionUrl
        window.open(`${sessionUrl}`, '_self')
      })
      .finally(() => {
        this.setState({ loading: 0 })
      })
  }

  openDeleteFlow = () => {
    const roleName = UserType[window.CONSTANTS.USER_ROLE_ID]
    if (SUBSCRIPTION_BOUND_ROLES.includes(roleName)) {
      this.setState({ openPaymentDialog: true })
      return
    }
    this.setState({ openDeleteDialog: true })
  }

  confirmDelete = () => {
    const { dispatch } = this.props
    this.setState({ openDeleteDialog: false })
    track('account_deleted', {
      user_email: window.CONSTANTS.EMAIL,
    })
    dispatch(authenticationDeleteAction())
  }

  render() {
    const { classes, hasHeader } = this.props
    const {
      hideFormArea,
      long,
      number,
      lowercase,
      uppercase,
      special,
      password,
      showPassword,
      disabled,
      openAlert,
      openDeleteDialog,
      openPaymentDialog,
      loading,
    } = this.state

    translator.changeLanguage(getCookie('language'))

    return (
      <div className={classes.div}>
        <Dialog
          open={openAlert}
          onClose={this.handleCloseAlert}
          classes={{ paper: classes.dialogPaper }}
        >
          <DialogContent>
            <Typography className={classes.dialogDescription}>
              {translator._('setPassword.passwordSameWithTheLastOne')}
            </Typography>
          </DialogContent>
          <DialogActions className={classes.dialogActions}>
            <CoreButton
              onClick={this.handleCloseAlert}
              color="primary"
              size="small"
            >
              {translator._('setPassword.ok')}
            </CoreButton>
          </DialogActions>
        </Dialog>

        <Dialog
          open={openPaymentDialog}
          onClose={() => this.setState({ openPaymentDialog: false })}
          classes={{ paper: classes.dialogPaper }}
        >
          <DialogContent>
            <Typography className={classes.dialogTitle}>
              Subscription Required
            </Typography>
            <Typography className={classes.dialogDescription}>
              You have an ongoing subscription. Please cancel your subscription
              first to delete your account.
            </Typography>
          </DialogContent>
          <DialogActions className={classes.dialogActions}>
            <CoreButton
              variant="outlined"
              color="dark"
              size="small"
              onClick={() => this.setState({ openPaymentDialog: false })}
            >
              {translator._('action.no')}
            </CoreButton>
            <CoreButton
              variant="contained"
              color="primary"
              size="small"
              onClick={() => {
                this.setState({ openPaymentDialog: false })
                this.handleDirectUrl()
              }}
            >
              Payment Details
            </CoreButton>
          </DialogActions>
        </Dialog>

        <Dialog
          open={openDeleteDialog}
          onClose={() => this.setState({ openDeleteDialog: false })}
          classes={{ paper: classes.deleteDialogPaper }}
        >
          <DialogContent className={classes.deleteDialogContent}>
            <div className={classes.deleteDialogHeader}>
              <div className={classes.deleteDialogIconWrap}>
                <div className={classes.deleteDialogIconCircle}>!</div>
              </div>
              <Typography className={classes.deleteDialogTitle}>
                Delete Account?
              </Typography>
            </div>
            <Typography className={classes.deleteDialogDescription}>
              Your account will be completely deleted and cannot be undone.
            </Typography>
          </DialogContent>
          <DialogActions className={classes.deleteDialogActions}>
            <CoreButton
              variant="text"
              color="dark"
              size="large"
              className={classes.deleteCancelButton}
              onClick={() => this.setState({ openDeleteDialog: false })}
            >
              Cancel
            </CoreButton>
            <CoreButton
              variant="contained"
              color="error"
              size="medium"
              className={classes.deleteConfirmButton}
              onClick={this.confirmDelete}
            >
              Delete
            </CoreButton>
          </DialogActions>
        </Dialog>

        <section className={classes.formSection}>
          {hasHeader && (
            <Typography className={classes.sectionTitle}>
              {translator._('setPassword.renewPassword')}
            </Typography>
          )}
          <div className={classes.divider} />

          {!hideFormArea && (
            <div className={classes.form}>
              <FormControl
                margin="normal"
                required
                fullWidth
                className={classes.input}
              >
                <Input
                  id="password"
                  placeholder="New Password"
                  inputProps={{
                    'aria-label': 'description',
                  }}
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={this.handleChange('password')}
                  label={translator._('setPassword.password')}
                  variant="outlined"
                  fullWidth
                  endAdornment={
                    password ? (
                      <InputAdornment position="end">
                        <CoreIconButton
                          aria-label="toggle password visibility"
                          onClick={this.handleClickShowPassword}
                          onMouseDown={this.handleMouseDownPassword}
                          variant="text"
                          color="dark"
                          size="small"
                        >
                          {showPassword ? (
                            <Icon icon="mdi:eye" />
                          ) : (
                            <Icon icon="mdi:eye-off" />
                          )}
                        </CoreIconButton>
                      </InputAdornment>
                    ) : null
                  }
                />
              </FormControl>

              <Requirements
                long={long}
                number={number}
                uppercase={uppercase}
                lowercase={lowercase}
                special={special}
                classes={classes}
              />

              <CoreButton
                variant="contained"
                color="primary"
                disabled={disabled}
                className={classes.submit}
                onClick={this.onHandleSetPassword}
              >
                {this.RenderButtonText()}
              </CoreButton>
            </div>
          )}
        </section>

        <section className={classes.deleteRow}>
          <Typography className={classes.deleteTitle}>Delete my account</Typography>
          {loading == 1 ? (
            <div className={classes.loadingWrap}>
              <CircularProgress size={20} />
            </div>
          ) : (
            <CoreButton
              variant="outlined"
              color="error"
              size="small"
              onClick={this.openDeleteFlow}
            >
              Delete my account
            </CoreButton>
          )}
        </section>
      </div>
    )
  }

  componentDidMount() {
    const { dispatch } = this.props
    dispatch(userGetSelfAction(() => {}))
  }

  RenderButtonText = () => {
    return translator._('setPassword.renewPassword')
  }
}

export default withStyles(styles)(withSnackbar(SetPasswordContainer))
